import { render, staticRenderFns } from "./CompanyIntroduction.vue?vue&type=template&id=910e422e&scoped=true"
import script from "./CompanyIntroduction.vue?vue&type=script&lang=js"
export * from "./CompanyIntroduction.vue?vue&type=script&lang=js"
import style0 from "./CompanyIntroduction.vue?vue&type=style&index=0&id=910e422e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910e422e",
  null
  
)

export default component.exports